import { useOperatorUsers } from "./OperatorUsersContext";
import React, { useState, useEffect } from "react";
import {
  Card,
  CardContent,
  CardHeader,
  CircularProgress,
  Dialog,
  IconButton,
  Table,
  TableCell,
  TableRow,
  Box,
  Checkbox,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const OperatorUserRoles = () => {
  const [open, setOpen] = useState(false);
  const {
    operatorUser,
    setOperatorUser,
    setReload,
    selectedRoleBtn,
    setSelectedRoleBtn,
    roles,
    setRoles,
  } = useOperatorUsers();

  useEffect(() => {
    setOpen(selectedRoleBtn);
  }, [selectedRoleBtn]);

  const onClose = (e, reason) => {
    setSelectedRoleBtn(false);
  };

  const isRoleExist = (role) => {
    return operatorUser.roles.indexOf(role) > -1;
  };

  const handleRole = (e) => {
    const checked = e.target.checked;
    const role = e.target.value;
    if (checked) {
      operatorUser.roles.push(role);
      setOperatorUser((operatorUser) => ({
        ...operatorUser,
        roles: operatorUser.roles,
      }));
    } else {
      const roleIdx = operatorUser.roles.indexOf(role);
      if (roleIdx !== -1) {
        setOperatorUser((operatorUser) => ({
          ...operatorUser,
          roles: operatorUser.roles.filter((ele) => ele != role),
        }));
      }
    }
  };
  return (
    <Dialog
      maxWidth="true"
      fullWidth={true}
      onClose={onClose}
      open={open}
      sx={{ overflow: "auto" }}
    >
      <IconButton
        aria-label="close"
        onClick={onClose}
        sx={{
          position: "absolute",
          right: 10,
          top: 8,
        }}
      >
        <CloseIcon />
      </IconButton>
      <Card sx={{ borderRadius: 3, overflow: "auto" }}>
        <CardHeader
          title={<font className="layer-title"> Operator User Roles </font>}
          align="center"
          className="styledtablerow"
        />
      </Card>
      <CardContent sx={{ padding: 1, paddingLeft: 0, paddingRight: 0 }}>
        {roles && operatorUser && (
          <Table size="small" sx={{ overflow: "auto" }}>
            <TableRow className="report-header">
              <TableCell></TableCell>
              <TableCell> Name </TableCell>
              <TableCell> Description </TableCell>
            </TableRow>
            {roles.map((eachRole, idx) => {
              return (
                <TableRow className={idx % 2 === 0 ? "styledtablerow" : ""}>
                  <TableCell>
                    <Checkbox
                      id={eachRole.name}
                      key={eachRole.name}
                      value={eachRole.name}
                      checked={isRoleExist(eachRole.name)}
                      onChange={handleRole}
                    ></Checkbox>
                  </TableCell>
                  <TableCell> {eachRole.name} </TableCell>
                  <TableCell> {eachRole.description} </TableCell>
                </TableRow>
              );
            })}
          </Table>
        )}
        {!roles && (
          <Box
            sx={{
              display: "flex",
              alignContent: "center",
              alignItems: "center",
              padding: 10,
              width: "100%",
            }}
          >
            <CircularProgress sx={{ margin: "auto" }} />
          </Box>
        )}
      </CardContent>
    </Dialog>
  );
};

export default OperatorUserRoles;
